var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('survey',{attrs:{"survey":_vm.survey}}),_c('div',{attrs:{"id":"surveyResult"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }